import React from "react";
import {
  Grid,
  List,
  ListItem,
  ListItemAvatar,
  Typography,
} from "@material-ui/core";
import "./style.css";
import { useTranslation } from "react-i18next";

export const PASSWORD_POLICY_VARIANTS = Object.freeze({
  DEFAULT: "default",
  SETTINGS_PAGE: "settings_page",
});

const PasswordPolicy = () => {
  const { t } = useTranslation();

  const passwordRules = [
    "passwordPolicy.passwordMinLength",
    "passwordPolicy.uppercaseRequired",
    "passwordPolicy.numberOrSpecialCharRequired",
  ];

  return (
    <Grid container direction="column" className="password-policy-container">
      <Typography variant="caption" className="txt-color">
        {t("passwordPolicy.passwordPolicyTitle")}
      </Typography>
      <List>
        {passwordRules.map((element) => (
          <ListItem>
            <ListItemAvatar>
              <i class="fas fa-circle txt-color list-icon" />
            </ListItemAvatar>
            <Grid container>
              <Typography variant="caption" className="txt-color">
                {t(element)}
              </Typography>
            </Grid>
          </ListItem>
        ))}
      </List>
    </Grid>
  );
};

export default PasswordPolicy;
